import { Modal } from 'bootstrap';
import { mount } from '../dom-lifecycle';

const KEY = 'beta-warning-dismissed';

mount('[data-beta-warning]', function () {
    if (sessionStorage.getItem(KEY)) return;

    const modal = new Modal(this, { backdrop: 'static', keyboard: false });
    this.addEventListener('hidden.bs.modal', () => sessionStorage.setItem(KEY, '1'));
    modal.show();
});
